import { SessionServiceErrorType } from "../../../../interfaces/session-management/enums/error-type";

export class SessionNotFoundError extends Error {
	public error: Error;

	constructor(message = '', error: Error = undefined) {
		super(message);
		this.name = SessionServiceErrorType.SESSION_NOT_FOUND_ERROR;
		this.error = error;

		Object.setPrototypeOf(this, SessionNotFoundError.prototype);
	}
}
